import type { AddParticipantApiResponse, GroupStatus, GroupStatusApiResponse } from '@/domain/groups/types';

export interface GroupMapper {
  map: (apiResponse?: GroupStatusApiResponse) => GroupStatus;
  mapAddParticipant: (apiResponse: AddParticipantApiResponse) => GroupStatus;
}

export const createGroupsMapper: () => GroupMapper = () => {
  const map = (apiResponse?: GroupStatusApiResponse): GroupStatus => {
    return {
      isValid: apiResponse?.isValid ?? false,
      groupName: apiResponse?.groupName ?? '',
      status: mapStatus(apiResponse?.subscriptionNonValidReasons),
      childBookingNumber: apiResponse?.availableSlot?.bookingNumber ?? 0,
      bookingCustomerId: apiResponse?.availableSlot?.bookingCustomerId ?? 0,
    };
  };

  const mapAddParticipant = (apiResponse: AddParticipantApiResponse): GroupStatus => {
    return {
      isValid: apiResponse.isSuccess ?? false,
      groupName: apiResponse?.data?.groupName ?? '',
      status: apiResponse.isSuccess ? 'success' : 'error',
      childBookingNumber: apiResponse?.data?.bookingNumber ?? 0,
      bookingCustomerId: apiResponse?.data?.bookingCustomerId ?? 0,
    };
  };

  return {
    map,
    mapAddParticipant,
  };
};

const mapStatus = (
  subscriptionNonValidReasons: string[] | null | undefined
): 'expired' | 'success' | 'full' | 'error' => {
  if (subscriptionNonValidReasons && subscriptionNonValidReasons.length === 0) {
    return 'success';
  }

  switch (subscriptionNonValidReasons?.[0]) {
    case 'OccupancyFull':
      return 'full';
    case 'DateLimitReached':
      return 'expired';
    default:
      return 'error';
  }
};
